import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/feature/AuthContext";

type Props = { children: React.ReactNode };

export default function SuperAdminRoute({ children }: Props) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
          <p className="text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== "super_admin") {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="text-center bg-white rounded-xl border border-gray-200 p-8 max-w-sm">
          <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-cross-line text-2xl text-red-600" />
          </div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-sm text-gray-500 mb-5">
            Only super admins can access this page. Please contact your administrator.
          </p>
          <a
            href="/dashboard"
            onClick={(e) => {
              e.preventDefault();
              window.REACT_APP_NAVIGATE("/dashboard");
            }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-sm font-medium text-white transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            Back to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}